import { Card, Drawer, Icon, IconButton, Tab, Tabs, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { useState } from "react";
import ConversationsListing from "./ConversationsListing";

/**
 * Displays conversations in a right-side drawer.
 * @param {boolean} open - Whether the drawer is open.
 * @param {function} onClose - Callback used to close the drawer.
 * @param {Object} action - Action configuration.
 * @param {Object} values - Values used to resolve the current contact.
 * @param {Object} resource - Resource configuration.
 * @returns {JSX.Element} The rendered component.
 */
const ListConversationsLight = ({ open, onClose, action, values, resource }) => {
	const [conversationsCount, setConversationsCount] = useState(0);
	const [fullScreen, setFullScreen] = useState(false);
	const [tab, setTab] = useState(0);

	const drawerStyles = fullScreen => ({
		"& .MuiDrawer-paper": {
			width: fullScreen ? "100vw" : "80vw",
			height: "100vh",
			display: "flex",
			flexDirection: "column",
			overflow: "hidden",
			margin: 0,
			boxSizing: "border-box",
			backgroundColor: "#fff",
			borderRadius: fullScreen ? 0 : "8px 0 0 8px",
			maxWidth: "100vw",
			padding: 0
		}
	});

	return (
		<Drawer open={open} onClose={onClose} anchor="right" sx={drawerStyles(fullScreen)}>
			<Card
				sx={{
					height: "100%",
					boxShadow: "none",
					borderRadius: 0,
					p: 0,
					display: "flex",
					flexDirection: "column",
					overflow: "hidden"
				}}
			>
				<MDBox
					display="flex"
					alignItems="center"
					justifyContent="space-between"
					sx={{ px: 2, py: 1 }}
				>
					<MDBox display="flex" justifyContent="start" flexDirection="column">
						<MDTypography variant="body2" fontSize="small">
							{conversationsCount || 0} conversation(s)
						</MDTypography>
					</MDBox>
					<MDBox display="flex">
						{/* Fullscreen toggle */}
						{!fullScreen ? (
							<Tooltip placement="top" title="Plein écran">
								<IconButton onClick={() => setFullScreen(true)}>
									<Icon>fullscreen</Icon>
								</IconButton>
							</Tooltip>
						) : (
							<Tooltip placement="top" title="Quitter le plein écran">
								<IconButton onClick={() => setFullScreen(false)}>
									<Icon>fullscreen_exit</Icon>
								</IconButton>
							</Tooltip>
						)}
						{/* Close drawer */}
						<Tooltip placement="top" title="Fermer">
							<IconButton onClick={onClose}>
								<Icon>close</Icon>
							</IconButton>
						</Tooltip>
					</MDBox>
				</MDBox>
				{!fullScreen && (
					<MDBox sx={{ px: 2 }}>
						<Tabs value={tab} onChange={(event, newValue) => setTab(newValue)} variant="fullWidth">
							<Tab label="Conversation(s)" />
							<Tab label="Archivées" />
						</Tabs>
					</MDBox>
				)}

				<MDBox sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
					{/* Active conversations */}
					{tab === 0 && (
						<ConversationsListing
							open={open}
							resource={resource}
							action={action}
							values={values}
							resourceCode={action?.config?.resourceCode}
							onCountChange={setConversationsCount}
						/>
					)}

					{/* Archived conversations */}
					{tab === 1 && (
						<ConversationsListing
							open={open}
							resource={resource}
							action={action}
							values={values}
							resourceCode={action?.config?.resourceCodeArchived}
							onCountChange={setConversationsCount}
						/>
					)}
				</MDBox>
			</Card>
		</Drawer>
	);
};

export default ListConversationsLight;
